import {
  logger,
  PanelActionOutcome,
  ActionGesture,
  PanelRegion,
  PanelLaunchMethod,
} from "@mwt/web-js-telemetry";

import {
  ScenarioName,
  ScenarioType,
  ModuleName,
  ModuleSummary,
  PanelType,
} from "../../telemetry/utils/constants";

export function logFinishedSessionAfterAudioTest() {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.FinishAfterAudioTest,
    actionScenarioType: ScenarioType.DeviceTestSession,
    actionGesture: ActionGesture.Click,
    actionOutcome: PanelActionOutcome.Nav,
    moduleName: ModuleName.FinishTestButton,
    moduleSummary: ModuleSummary.FinishAfterAudioTest,
    panelType: PanelType.AudioTest,
    panelLaunchMethod: PanelLaunchMethod.UserInitiated,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}
